import $ from 'jquery';
import BaseComponent from '../../../general/js/base-component';

export default class OfferComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.openLink = this.refs.openLink;
        this.offerForm = this.refs.offerForm;

        this.init();
    }

    init() {
        if(this.openLink && this.offerForm){
            this.openLink.addEventListener('click', this.open.bind(this));
        }
    }

    open(e){
        e.preventDefault();

        if(!this.offerForm.classList.contains('is-opened')){
            $(this.offerForm).slideDown(400, () => {
                this.offerForm.classList.add('is-opened');
            });
        }

        this.offerForm.getElementsByTagName('INPUT')[0].focus();
    }
}




// WEBPACK FOOTER //
// ./app/components/offer/js/offer.component.js